export class ImportarIndicesBcraRequest {
  /** ICL o USD. El IPC lo publica el INDEC, no el BCRA. */
  public idTipoAjusteContrato!: number
  public fechaDesde!: string
  public fechaHasta!: string
}

/** Un valor del rango, con qué se hizo con él */
export class IndiceImportadoDto {
  public fecha!: string
  public valor!: number
  /** "Importado" | "Ya existía" */
  public estado!: string
}

/**
 * Resultado de la importación.
 *
 * Las tres categorías se informan por separado porque significan cosas distintas:
 * "ya existía" es esperable al reimportar un rango; "con error" hay que mirarlo.
 */
export class ImportarIndicesBcraResponse {
  public importados: number = 0
  public yaExistian: number = 0
  public conError: number = 0
  public totalRecibidos: number = 0
  public detalle: IndiceImportadoDto[] = []
  public errores: string[] = []
  public mensaje: string = ""
}
